import ApiService from '@/services/api'

const state = {
  classes: [],
  loading: false,
  error: null
}

const mutations = {
  SET_CLASSES(state, classes) {
    state.classes = classes
  },
  
  SET_LOADING(state, status) {
    state.loading = status
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchClasses({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await ApiService.get('/Classe')
      
      const data = response.data || response || []
      
      commit('SET_CLASSES', data)
      return data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Erro ao carregar classes'
      commit('SET_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  getAllClasses: (state) => state.classes,
  
  classesCount: (state) => state.classes.length,
  
  isLoadingClasses: (state) => state.loading,
  
  classesError: (state) => state.error,
  
  getClasseById: (state) => (id) => {
    return state.classes.find(classe => classe.id === id)
  },
  
  getClasseByName: (state) => (name) => {
    return state.classes.find(classe => 
      classe.name?.toLowerCase() === name.toLowerCase()
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}